import { Skeleton } from "@bsf/force-ui";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { useState } from "react";
import { __ } from '@wordpress/i18n';

const videoData = [
  {
    id: 1,
    videoId: "kXuXfaetch4",
    title: __("Video Tutorial 1", 'uael')
  },
  {
    id: 2,
    videoId: "8fu8W4quFg0",
    title: __("Video Tutorial 2", 'uael')
  },
  {
    id: 3,
    videoId: "wwu4ZzXrhGc",
    title: __("Video Tutorial 3", 'uael')
  },
  {
    id: 4,
    videoId: "88kTeBv4mWY",
    title: __("Video Tutorial 4", 'uael')
  },
  {
    id: 5,
    videoId: "NovIe5b2EkQ",
    title: __("Video Tutorial 5", 'uael')
  },
  {
    id: 6,
    videoId: "kaGfSpGFcnw",
    title: __("Video Tutorial 6", 'uael')
  },
  {
    id: 7,
    videoId: "7Q-3fAKKhbg",
    title: __("Video Tutorial 7", 'uael')
  },
  {
    id: 8,
    videoId: "qhFfKf2R-SM",
    title: __("Video Tutorial 8", 'uael')
  },
  {
    id: 9,
    videoId: "jWzW_oT1iSQ",
    title: __("Video Tutorial 9", 'uael')
  },
  {
    id: 10,
    videoId: "-FErpbu2F58",
    title: __("Video Tutorial 10", 'uael')
  },
  {
    id: 11,
    videoId: "hrDAFmPTDgg",
    title: __("Video Tutorial 11", 'uael')
  },
  {
    id: 12,
    videoId: "2RlvBU_EFV4",
    title: __("Video Tutorial 12", 'uael')
  },
  {
    id: 13,
    videoId: "7m6FD8Yk3N0",
    title: __("Video Tutorial 13", 'uael')
  },
  {
    id: 14,
    videoId: "OCD3oZas60w",
    title: __("Video Tutorial 14", 'uael')
  },
  {
    id: 15,
    videoId: "K4gCczaX-Sg",
    title: __("Video Tutorial 15", 'uael')
  },
  {
    id: 16,
    videoId: "Izbr-oO0VkU",
    title: __("Video Tutorial 16", 'uael')
  },
  {
    id: 17,
    videoId: "ruGOgho6RQM",
    title: __("Video Tutorial 17", 'uael')
  },
  {
    id: 18,
    videoId: "8N_CW1rgvp0",
    title: __("Video Tutorial 18", 'uael')
  },
  {
    id: 19,
    videoId: "WmrSMl5g3ac",
    title: __("Video Tutorial 19", 'uael')
  },
  {
    id: 20,
    videoId: "BqXOvmpulQQ",
    title: __("Video Tutorial 20", 'uael')
  },
  {
    id: 21,
    videoId: "bVfJNMZOsv0",
    title: __("Video Tutorial 21", 'uael')
  },
  {
    id: 22,
    videoId: "IigQsUdvcRo",
    title: __("Video Tutorial 22", 'uael')
  },
  {
    id: 23,
    videoId: "tZRjCiUFa-o",
    title: __("Video Tutorial 23", 'uael')
  },
  {
    id: 24,
    videoId: "TJmcPWToHU0",
    title: __("Video Tutorial 24", 'uael')
  },
  {
    id: 25,
    videoId: "XuQZzQJbNas",
    title: __("Video Tutorial 25", 'uael')
  },
  {
    id: 26,
    videoId: "Eh8a3skmVDM",
    title: __("Video Tutorial 26", 'uael')
  },
  {
    id: 27,
    videoId: "zGvbznihzH8",
    title: __("Video Tutorial 27", 'uael')
  },
  {
    id: 28,
    videoId: "lgCG5--xyR4",
    title: __("Video Tutorial 28", 'uael')
  },
  {
    id: 29,
    videoId: "p3zlIYoaaG0",
    title: __("Video Tutorial 29", 'uael')
  },
];

// New component to handle lazy-loading of YouTube thumbnails
const VideoThumbnail = ({ videoId, title, playingVideoId, setPlayingVideoId }) => {
  const isPlaying = playingVideoId === videoId;

  const handlePlayVideo = () => {
    setPlayingVideoId(videoId);
  };

  return (
    <div className="video-thumbnail-container" onClick={handlePlayVideo} style={{ cursor: 'pointer' }}>
      {isPlaying ? (
        <iframe
          width="250"
          height="145"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          frameBorder="0"
          style={{ borderRadius: "8px" }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title}
        />
      ) : (
        <div style={{ position: 'relative' }}>
          <img
            src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
            alt={title}
            width="250"
            height="145"
            style={{ borderRadius: "8px" }}
          />
          <img
            src={`${uaelSettingsData.video_control}`}
            alt="Play"
            style={{ left: "43%", top: "50%", transform: "translate(-50%, -50%)" }}
            className="absolute inset-0 w-11 h-11"
          />
        </div>
      )}
    </div>
  );
};

// VideoTutorials Component
export default function VideoTutorials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [playingVideoId, setPlayingVideoId] = useState(null); // Track the currently playing video

  const nextSlide = () => {
    if (currentIndex < videoData.length - 3) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="rounded-lg bg-white w-full mb-4">
      <div
        className="flex items-center justify-between p-4"
        style={{
          paddingBottom: "0",
        }}
      >
        <p className="m-0 text-sm pt-4 pl-3 font-semibold text-text-primary">
          {__("Video Tutorials", "uael")}
        </p>
        <div className="flex items-center cursor-pointer gap-x-2 mr-7">
          <ChevronLeft
            className={
              currentIndex === 0 ? "text-gray-300 cursor-not-allowed" : "cursor-pointer"
            }
            onClick={prevSlide}
          />
          <ChevronRight
            className={
              currentIndex >= videoData.length - 3
                ? "text-gray-300 cursor-not-allowed"
                : "cursor-pointer"
            }
            onClick={nextSlide}
          />
        </div>
      </div>
      <div className="overflow-hidden bg-black flex-col rounded-lg px-4 py-2 relative">
        <div
          className="flex transition-transform duration-300 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * (100 / videoData.length)}%)`,
            width: `${(videoData.length / 2.95) * 100}%`,
          }}
        >
          {videoData.map((video) => (
            <div key={video.id} className="w-1/3 py-2 px-1">
              <VideoThumbnail
                videoId={video.videoId}
                title={video.title}
                playingVideoId={playingVideoId}
                setPlayingVideoId={setPlayingVideoId}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
